var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDateBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Broken_Time_Circle",
    "data-name": "Iconly/Broken/Time Circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Time_Circle",
    "data-name": "Time Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Time_Circle-2",
    "data-name": "Time Circle",
    d: "M2.073,16.1a.727.727,0,0,1,1.152-.888A8.548,8.548,0,1,0,1.455,10a8.635,8.635,0,0,0,.1,1.3.727.727,0,0,1-.608.828.719.719,0,0,1-.828-.608A10,10,0,1,1,2.073,16.1Zm11-2.524L9.288,11.32a.73.73,0,0,1-.354-.625V5.837a.727.727,0,1,1,1.453,0v4.446l3.425,2.042a.727.727,0,0,1-.744,1.249Z",
    fill: "#3f5ec1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateBlue);
export default __webpack_public_path__ + "static/media/dateBlue.05f01b2c8171fbf40fc61d9237c42c8f.svg";
export { ForwardRef as ReactComponent };